import { formatLocalizedDateTime } from "../../utils/localized-date.util";
import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-common-plan-accordion",
  templateUrl: "./common-plan-accordion.component.html",
  styleUrl: "./common-plan-accordion.component.scss",
})
export class CommonPlanAccordionComponent {
  @Input() plansMapforExperiment: { [experimentId: string]: any[] } = {};
  @Input() planogramUsers: { [userId: string]: string } = {};
  @Input() data: any;
  @Input() actionIconList: any[] = [];
  @Output() actionAccordianCallback = new EventEmitter<any>();

  getPlans(data: any): any[] {
    const plansList = this.plansMapforExperiment[data?.id] ?? [];
    plansList &&
      plansList.map((plan: any) => {
        let createdBy = plan.created_by || plan.user;
        if (createdBy in this.planogramUsers) {
          plan.owner_by = this.planogramUsers[createdBy];
        }
        return plan;
      });

    return plansList;
  }

  actionCallback(action: string, planData: any, experimentData: any) {
    this.actionAccordianCallback.emit({ action, planData, experimentData });
  }

  formatHumanReadableDate(dateStr: string): string {
    if (!dateStr) {
      return "-";
    }
    const inputDateObj = new Date(dateStr + "Z");
    const now = new Date();

    const inputDay = new Date(
      inputDateObj.getFullYear(),
      inputDateObj.getMonth(),
      inputDateObj.getDate()
    );
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const relative =
      inputDay.getTime() === today.getTime()
        ? "today"
        : inputDay.getTime() === yesterday.getTime()
          ? "yesterday"
          : null;
    return formatLocalizedDateTime(inputDateObj, relative);
  }
}
